import { LoginResponse } from '../auth/auth.type'
import { w3Api } from '../w3Api'

export const authEndpoints = {
  tutorial: '/user/write/finish-tutorial',
}
const authApi = w3Api.injectEndpoints({
  endpoints: (build) => ({
    markUserVisited: build.mutation<LoginResponse, void>({
      query: () => {
        return {
          url: authEndpoints.tutorial,
          method: 'PUT',
        }
      },
    }),
  }),
  overrideExisting: false,
})

export const { useMarkUserVisitedMutation } = authApi
